import { v4 as uuidv4 } from 'uuid';

export function ProductListPrice(props = {}) {
	return {
		componentName: 'ProductListPrice',
		componentId: uuidv4(),
		props: Object.assign(
			{
				markers: [],
				message: '',
				alwaysShow: false,
			},
			props,
		),
		childrenComponents: [],
	};
}
